import { render, staticRenderFns } from "./QuestionUpdateHistory.vue?vue&type=template&id=796a9647&scoped=true&"
import script from "./QuestionUpdateHistory.vue?vue&type=script&lang=js&"
export * from "./QuestionUpdateHistory.vue?vue&type=script&lang=js&"
import style0 from "./QuestionUpdateHistory.vue?vue&type=style&index=0&id=796a9647&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796a9647",
  null
  
)

export default component.exports